import React, {useState} from "react";
import * as Styled from "./CareerContentCompStyled";
import CareerContentItemComp from "./CareerContentItemComp";
import data from '../../constants/data/CareerPageData.json';
import {Select} from "@mantine/core";
import {useForm} from "@mantine/form";
import Image from "next/image";
import {NavigationURLs} from "../../functions/NavigationFunctions";
import GeneralBreadcrumb from "../breadcrumb/GeneralBreadcrumbComp";


const CareerContentComp = () => {

    const [selectedCategory, setSelectedCategory] = useState<'All' | 'Dijital Satış ve Operasyon Uzmanı' | 'IT Stajyeri' | 'Genel Başvuru'>('All');


    type FormValues = {
        selectedCategory: string;
    }

    const form = useForm<FormValues>({
        initialValues: {
            selectedCategory: 'All'
        },
    });

    function handleCategoryChange(event: any) {
        form.setFieldValue('selectedCategory', event);
    }

    const breadcrumbItemsKariyer = [
        { label: 'Pembe Panjur', link: NavigationURLs.landing },
        { label: 'Kariyer'}
    ];

    return (
        <Styled.CareerContentCompWrapper>
            <Styled.CareerContentJobPostings>
                <Styled.CareerContentJobPostingsTitle>
                    <Styled.CareerContentJobPostingsTitleText>
                    <GeneralBreadcrumb items={breadcrumbItemsKariyer} margin={false} colorProps={false}/>
                        Pembe Panjur iş ilanları
                    </Styled.CareerContentJobPostingsTitleText>
                </Styled.CareerContentJobPostingsTitle>
                <Styled.CareerContentJobPostingsDetails>
                    <p>
                        Panjur Bilişim ve Danışmanlık Hizmetleri Ticaret A.Ş., yenilikçi, öncü ve istikrarlı kurum
                        kimliğiyle 2010 yılından beri bilişim sektöründe hizmet vermektedir. Alanının lider firmalarından
                        biri olan Panjur Bilişim'in kurduğu Pembe Panjur evlilik sitesi, teknolojik altyapısı ve 10 milyonun
                        üzerinde üyesiyle Türkiye'nin en büyük evlilik sitesi unvanına sahiptir.
                    </p>
                    <p>
                        Profesyonel, etik değerlere saygılı, hizmette kaliteyi hedefleyen Panjur Bilişim, üyelerine sunduğu
                        servislerle maksimum faydayı gözetmektedir.
                    </p>
                    <p>
                        Çalışan kültürüne büyük önem veren Panjur Bilişim kendini sürekli yenileyerek büyüme amacına uygun
                        bir yaklaşım sergilemektedir. Panjur Bilişim çalışanları alanında tecrübeli, yaratıcı, özverili,
                        ekip ruhuna sahip ve dinamik bireylerden oluşmaktadır.
                    </p>
                </Styled.CareerContentJobPostingsDetails>
                <Styled.CareerContentJobPostingsList id={'view-position'}>
                    <Styled.CareerContentJobPostingsListItem>
                        <Styled.CareerContentJobPostingsListItemIcon>
                            <Image loading={'lazy'} width={106}
                                   height={101}
                                   sizes={'100vw'}
                                   style={{width: '100%', height: 'auto'}}
                                   src={`/next/assets/images/career/career-icon.svg`}
                                   alt={'Pembe Panjur Kariyer'} title={'Pembe Panjur Kariyer'}
                            />
                        </Styled.CareerContentJobPostingsListItemIcon>
                        <Styled.CareerContentJobPostingsListItemContent>
                            <Styled.CareerContentJobPostingsListItemContentDropdown>
                                <Select data={[
                                    {value: 'All', label: 'Tümünü listele'},
                                    {
                                        value: 'Dijital Satış ve Operasyon Uzmanı',
                                        label: 'Dijital Satış ve Operasyon Uzmanı'
                                    },
                                    {value: 'IT Stajyeri', label: 'IT Stajyeri'},
                                    {value: 'Genel Başvuru', label: 'Genel Başvuru'},
                                ]}
                                        className={'career-select'} onChange={handleCategoryChange}
                                        placeholder={'Tümünü listele'}
                                        rightSection={
                                            <Image loading={'lazy'} width={25}
                                                   height={14}
                                                   sizes={'100vw'}
                                                   style={{width: '25px', height: '14px'}}
                                                   src={`/next/assets/images/career/career-arrow-icon.svg`}
                                                   alt={'Pembe Panjur Kariyer'} title={'Pembe Panjur Kariyer'}
                                            />
                                        }
                                        rightSectionWidth={65}
                                        styles={(theme) => ({
                                            padding: '10px 20px',
                                            rightSection: {
                                                pointerEvents: 'none',
                                                '& img': {
                                                    position: 'absolute',
                                                    right: 20,
                                                    top: '50%',
                                                    transform: 'translateY(-50%)',
                                                    '@media (max-width: 767px)': {
                                                        right: 15,
                                                    },
                                                },
                                                '@media (max-width: 767px)': {
                                                    display: 'none',
                                                },
                                            },
                                            item: {
                                                color: '#000',
                                                '&:hover': {
                                                    color: '#752280',
                                                },
                                                '&[data-selected]': {
                                                    '&, &:hover': {
                                                        backgroundColor: '#752280',
                                                        color: '#fff',
                                                        '@media (max-width: 767px)': {
                                                            backgroundColor: '#D2147D',
                                                        },
                                                    },
                                                    color: '#fff',
                                                },
                                            },
                                            input: {
                                                color: '#fff',
                                                backgroundColor: '#752280',
                                                border: 'none',
                                                '&::placeholder': {
                                                    color: '#fff',
                                                },
                                                fontFamily: 'Manrope, sans-serif',
                                                fontWeight: 800,
                                                fontSize: 16,
                                                lineHeight: '24px',
                                                letterSpacing: '0',
                                                textTransform: 'uppercase',
                                                height: 'auto',
                                                minHeight: 47,
                                                '@media (max-width: 767px)': {
                                                    fontWeight: 700,
                                                    fontSize: 14,
                                                    lineHeight: '19px',
                                                    backgroundColor: '#D2147D',
                                                    paddingLeft: 0,
                                                    paddingRight: 0,
                                                },
                                            },
                                        })}
                                        transitionProps={{
                                            transition: 'pop-top-left',
                                            duration: 80,
                                            timingFunction: 'ease'
                                        }}
                                />
                                {/*<select name="category-list" id="category-list" onChange={handleCategoryChange}>*/}
                                {/*    <option value="All">Tümünü listele</option>*/}
                                {/*    <option value="Dijital Satış ve Operasyon Uzmanı">Dijital Satış ve Operasyon Uzmanı</option>*/}
                                {/*    <option value="IT Stajyeri">IT Stajyeri</option>*/}
                                {/*    <option value="Genel Başvuru">Genel Başvuru</option>*/}
                                {/*</select>*/}
                            </Styled.CareerContentJobPostingsListItemContentDropdown>
                        </Styled.CareerContentJobPostingsListItemContent>
                    </Styled.CareerContentJobPostingsListItem>
                </Styled.CareerContentJobPostingsList>
            </Styled.CareerContentJobPostings>

            {form.values.selectedCategory === "All" || form.values.selectedCategory === "Dijital Satış ve Operasyon Uzmanı" ? (
                <Styled.CareerContentJobPostings>
                    <Styled.CareerContentJobTitle>
                        <Styled.CareerContentJobTitleText>
                            Dijital Satış ve Operasyon Uzmanı
                        </Styled.CareerContentJobTitleText>
                    </Styled.CareerContentJobTitle>
                    {data.CareerPageData.filter((item) => {
                        return item.category === "Dijital Satış ve Operasyon Uzmanı";
                    }).map((element, index) => (
                        <CareerContentItemComp {...element} key={index}/>
                    ))}
                </Styled.CareerContentJobPostings>
            ) : null}

            {form.values.selectedCategory === "All" || form.values.selectedCategory === "IT Stajyeri" ? (
                <Styled.CareerContentJobPostings>
                    <Styled.CareerContentJobTitle>
                        <Styled.CareerContentJobTitleText>
                            IT Stajyeri
                        </Styled.CareerContentJobTitleText>
                    </Styled.CareerContentJobTitle>
                    {data.CareerPageData.filter((item) => {
                        return item.category === "IT Stajyeri";
                    }).map((element, index) => (
                        <CareerContentItemComp {...element} key={index}/>
                    ))}
                </Styled.CareerContentJobPostings>
            ) : null}


            {form.values.selectedCategory === "All" || form.values.selectedCategory === "Genel Başvuru" ? (
                <Styled.CareerContentJobPostings>
                    <Styled.CareerContentJobTitle>
                        <Styled.CareerContentJobTitleText>
                            Genel Başvuru
                        </Styled.CareerContentJobTitleText>
                    </Styled.CareerContentJobTitle>
                    {data.CareerPageData.filter((item) => {
                        return item.category === "Genel Başvuru";
                    }).map((element, index) => (
                        <CareerContentItemComp {...element} key={index}/>
                    ))}
                </Styled.CareerContentJobPostings>
            ) : null}


        </Styled.CareerContentCompWrapper>
    )
}

export default CareerContentComp;
